import {GetRoutes} from '../lib/api/GET/GetRoutes';
import {Rejection} from '../types/shared-recruiting-types';

import {useApiRead} from './useApiRead';

type UseRejectionReasonsOptions = {
  /** When false, the config request is skipped (defaults to true). */
  enabled?: boolean;
};

export const useRejectionReasons = (rejectionType: string, queryOptions?: UseRejectionReasonsOptions) => {
  const {data, isLoading} = useApiRead<Rejection[]>({
    path: GetRoutes.matchRejectionReasons(rejectionType),
    options: {
      enabled: queryOptions?.enabled ?? true,
    },
  });

  return {
    data,
    isLoading,
  };
};
